<template>
  <b-col md="5" sm="12" class="pt-4 pb-5">
    <canvas style="min-height: 500px" ref="myChart" :id="id"></canvas>
  </b-col>
</template>

<script>
import Chart from "chart.js";
import initChartConfig from "@/utility/initChartConfig.js";

export default {
  name: "ChartLine",
  props: {
    id: {
      type: String,
      required: true
    },
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: {}
    };
  },
  created() {
    initChartConfig();
  },
  mounted() {
    this.getContext();
  },
  methods: {
    getContext() {
      const ctx = this.$refs.myChart.getContext("2d");
      this.chart = new Chart(ctx, { type: "line", ...this.config });
    }
  },
  watch: {
    config() {
      this.chart && this.chart.destroy();
      this.getContext();
    }
  }
};
</script>

<style lang="scss" scoped></style>
